import * as React from "react";
import { useAlerts, type UseAlertsReturn } from "@/hooks/use-alerts";

// ─── Context ─────────────────────────────────────────────────────────────────

const AlertsContext = React.createContext<UseAlertsReturn | null>(null);

// ─── Provider ─────────────────────────────────────────────────────────────────

export function AlertsProvider({ children }: { children: React.ReactNode }) {
  const alertsData = useAlerts({ autoLoad: true });

  return (
    <AlertsContext.Provider value={alertsData}>
      {children}
    </AlertsContext.Provider>
  );
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useAlertsContext(): UseAlertsReturn {
  const ctx = React.useContext(AlertsContext);
  if (!ctx) {
    throw new Error("useAlertsContext must be used within an AlertsProvider");
  }
  return ctx;
}
